// extracted by mini-css-extract-plugin
export var entitlementsSubTabTabs = "entitlements-sub-tab__tabs_VXbPv1Z2wc4G05Cz0nqC";
export var entitlementsSubTabTitle = "entitlements-sub-tab__title_gZOlSwkxSDw5Medt2BQH";